import "@/styles/libs/swiper-overrides.css";
import cn from "classnames";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
export type MobileCarouselProps = {
  slides: {
    image: React.ReactNode;
    title: string;
  }[]
  isOnDark?: boolean;
}

const MobileCarousel = ({ slides, isOnDark = true }: MobileCarouselProps) => {
  return (
    <div className="flex md:hidden w-full flex-wrap justify-center mt-[48px] relative">
      <Swiper
        pagination={{ type: "bullets", clickable: true }}
        slidesPerView={1.2}
        centeredSlides={true}
        spaceBetween={20}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
        }}
        loop={true}
        modules={[Autoplay, Pagination]}
      >
        {slides.map((feature, index) =>
          <SwiperSlide key={`swiper-key-${index}`}>
            <div className="flex flex-wrap">
              <div className="flex w-full rounded-10 overflow-hidden">
                {feature.image}
              </div>
              <div className={cn("flex w-full justify-center font-500 text-h4 mt-[24px]", {
                "text-white": isOnDark,
                "text-black": !isOnDark
              })}>
                {feature.title}
              </div>
            </div>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  )
}

export default MobileCarousel;
